/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSettingsInputModuleId } from './courseModuleSettingsInputModuleId';
import type { CourseModuleSettingsInputSortIndex } from './courseModuleSettingsInputSortIndex';
import type { CourseModuleSettingsInputAllowPartialSubmission } from './courseModuleSettingsInputAllowPartialSubmission';
import type { CourseModuleSettingsInputEcts } from './courseModuleSettingsInputEcts';
import type { CourseModuleSettingsInputLearningHours } from './courseModuleSettingsInputLearningHours';
import type { CourseModuleSettingsInputExamTaskIds } from './courseModuleSettingsInputExamTaskIds';
import type { CourseModuleSettingsInputSegmentId } from './courseModuleSettingsInputSegmentId';
import type { CourseModuleSettingsInputEnabledEventKinds } from './courseModuleSettingsInputEnabledEventKinds';
import type { CourseModuleSettingsInputMandates } from './courseModuleSettingsInputMandates';

/**
 * Properties of a Module in a Course
 */
export interface CourseModuleSettingsInput {
  moduleId?: CourseModuleSettingsInputModuleId;
  sortIndex?: CourseModuleSettingsInputSortIndex;
  allowPartialSubmission?: CourseModuleSettingsInputAllowPartialSubmission;
  ects?: CourseModuleSettingsInputEcts;
  learningHours?: CourseModuleSettingsInputLearningHours;
  examTaskIds?: CourseModuleSettingsInputExamTaskIds;
  segmentId?: CourseModuleSettingsInputSegmentId;
  enabledEventKinds?: CourseModuleSettingsInputEnabledEventKinds;
  mandates?: CourseModuleSettingsInputMandates;
}
